<template>
  <div>
    <h1>Welkom bij ZorgSpot!</h1>
    <br>
    <v-card v-if="!loggedIn" class="no-border-shadow no-background-color">
      Om gebruik te kunnen maken van de ZorgSpot en de actuele aanvragen te kunnen zien, is het nodig dat je ingelogd bent met je Cedin Zorg account.<br /><br />
      <v-btn primary class="no-border-shadow no-margin btn-blue" v-if="!loggedIn" @click.stop="$router.push({ name: 'login' })">
        Inloggen
      </v-btn>
      <br /><br />
      Heb je hulp nodig bij het gebruik van deze app?Neem dan contact met ons op via <a href="mailto:info@cedinsupport.nl">info@cedinsupport.nl</a>.
    </v-card>

    <v-card v-if="loggedIn" class="no-border-shadow no-background-color">
      Hallo {{ user.name }}, welkom in de ZorgSpot app van Cedin Zorg. Hier kun je de actuele aanvragen zien en hier op reageren.<br /><br />
      <v-btn class="no-border-shadow no-margin btn-blue" v-if="loggedIn" @click.stop="$router.push({ name: 'offers' })">
        Ga naar de aanvragen &rsaquo;
      </v-btn>
      <br /><br />
      Voor de andere pagina's kun je kijken in het menu, te openen via de knop rechts onderin het scherm.<br /><br />
      Heb je hulp nodig bij het gebruik van deze app? Neem dan contact met ons op via <a href="mailto:info@cedinsupport.nl">info@cedinsupport.nl</a>.
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("user", ["loggedIn", "user"])
  }
};
</script>

<style scoped></style>
